import action from './action.json';
import air from './air.json';
import application from './application.json';
import applications from './applications.json';
import auth from './auth.json';
import common from './common.json';
import dictionary from './dictionary.json';
import externalOffer from './externalOffer.json';
import jobOrder from './jobOrder.json';
import jobOrderList from './jobOrderList.json';
import meetingSchedule from './meetingSchedule.json';
import modal from './modal.json';
import notification from './notification.json';
import onboarding from './onboarding.json';
import pageTitles from './pageTitles.json';
import profile from './profile.json';
import settings from './settings.json';
import slides from './slides.json';
import toast from './toast.json';
import validation from './validation.json';
import welcomePanel from './welcomePanel.json';

export const pl = {
  action,
  auth,
  common,
  dictionary,
  meetingSchedule,
  externalOffer,
  application,
  onboarding,
  validation,
  pageTitles,
  profile,
  jobOrder,
  welcomePanel,
  applications,
  jobOrderList,
  toast,
  modal,
  slides,
  notification,
  settings,
  air,
};
